import type { FaireProductEntity } from "../../entity_types/product";

export const p_csbb6vycn7: FaireProductEntity = {
  token: "p_csbb6vycn7",
  type: "product",
  name: "NEW! Soy Wax Melt Jar - Very Vanilla",
  brandName: "Classic Farmhouse Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/642d60c8532c71ed5d9971040268cdeb0e75c396748bad936a6b02ea95d0806b.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8c36a97f0780a9bd1dbdf1a4f2348aceb175c54d3e0001bec00c2542fed8971d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
